export const appLocalStorage = {
    methods: {
        // Functions to show/hide the splash screen
        SetShowLoader: function (value) {
            return localStorage.showLoader = value;
        },
        GetShowLoader: function () {
            return typeof localStorage.showLoader === 'undefined'
                ? true
                : localStorage.showLoader === 'true';
        },
        // Functions to apply the 'fadeout' animation on the splash screen
        SetFadeoutLoader: function (value) {
            return localStorage.fadeoutLoader = value;
        },
        GetFadeoutLoader: function () {
            return typeof localStorage.fadeoutLoader === 'undefined'
                ? false
                : localStorage.fadeoutLoader === 'true';
        }
    }
}